
import { defineComponent, reactive, ref, toRefs, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { toResult } from '@/utils/toResult'
import { editApi } from '../api'
import { enumToOption } from '@/utils'
import { moduleType } from '../config'

export default defineComponent({
  name: 'enterprise-api-setting-edit-dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    rowData: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['update:visible', 'refresh-list'],
  setup(props, { emit }) {
    const formRef = ref<HTMLElement | any>(null)
    const state = reactive({
      isShow: false,
      loading: false,
      formData: {
        id: '',
        uuid: '',
        companyUuid: '',
        companyName: '',
        appId: '',
        aesKey: '',
        signKey: '',
        notifyUrl: '',
        modules: [] as number[],
        status: 1
      } as any,
      rules: {
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    })

    const moduleOptions = enumToOption(moduleType)

    watch(
      () => props.visible,
      val => {
        state.isShow = val
        if (val) {
          Object.assign(state.formData, {
            id: props.rowData?.id,
            uuid: props.rowData?.uuid,
            companyUuid: props.rowData?.companyUuid,
            companyName: props.rowData?.companyName,
            appId: props.rowData?.appId,
            aesKey: props.rowData?.aesKey,
            signKey: props.rowData?.signKey,
            notifyUrl: props.rowData?.notifyUrl,
            modules: props.rowData?.modules || [],
            status: props.rowData?.status
          })
        }
      },
      { immediate: true }
    )

    /**
     * @description: 关闭弹窗
     * @return {void}
     */
    const handleClose = (): void => {
      state.isShow = false
      formRef.value?.resetFields()
      emit('update:visible', false)
    }

    /**
     * @description: 提交表单
     * @return {void}
     */
    const handleSubmit = async (): Promise<void> => {
      state.loading = true
      const submitData = {
        id: state.formData.id,
        notifyUrl: state.formData.notifyUrl,
        modules: state.formData.modules,
        status: state.formData.status
      }
      const [err, , msg] = await toResult(editApi(submitData))
      state.loading = false
      if (err) return
      ElMessage.success(msg || '编辑成功')
      emit('refresh-list')
      handleClose()
    }

    /**
     * @description: 校验
     * @return {void}
     */
    const handleValidate = (): void => {
      formRef.value?.validate((valid: boolean) => {
        if (!valid) return
        handleSubmit()
      })
    }

    return {
      ...toRefs(state),
      formRef,
      moduleOptions,
      handleClose,
      handleValidate
    }
  }
})
